import React, {useEffect, useMemo} from 'react';
import {normalizeGamePush} from '@/utils/game';
import {DotLoading, InfiniteScroll} from 'antd-mobile';
import {useHomeStore} from '../store';
import useInfiniteList from '@/hooks/useInfiniteList';
import {getGamePicUrl, GamePicType} from '@/components/utils/utils';

const InfiniteScrollContent = ({hasMore}: {hasMore?: boolean}) => {
  return (
    <>
      {hasMore ? (
        <>
          <span>Loading</span>
          <DotLoading />
        </>
      ) : (
        <span>--- No more data ---</span>
      )}
    </>
  );
};

export default function Casino() {
  const {fetchCasinoGames, selectedProvider, selectedGameType} = useHomeStore();

  const fetchData = useMemo(() => {
    return ({page, pageSize}: {page: number; pageSize: number}) => {
      return fetchCasinoGames({page, pageSize});
    };
  }, [fetchCasinoGames]);

  const {
    items: casinoGames,
    hasMore,
    loadMore,
    refresh,
    reset,
  } = useInfiniteList({
    fetchData,
    pageSize: 21,
  });

  // 当provider或gameType改变时重置数据
  useEffect(() => {
    reset();
    refresh();
  }, [selectedProvider, selectedGameType, reset, refresh]);

  return (
    <div>
      <div className="grid grid-cols-3 gap-2 px-3">
        {casinoGames.map(game => (
          <div
            key={game.id}
            className="aspect-square"
            onClick={() => normalizeGamePush(game.id, true)}>
            <img
              src={getGamePicUrl(
                GamePicType.V_RECTANGLE,
                game.source,
                game.tripartiteUniqueness,
              )}
              alt={game.name}
              className="w-full aspect-[375/520] object-cover rounded-lg"
            />
          </div>
        ))}
      </div>
      <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
        <InfiniteScrollContent hasMore={hasMore} />
      </InfiniteScroll>
    </div>
  );
}
